exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-baea85f2]{margin-top:35px}.handle[data-v-baea85f2]{float:left}.close[data-v-baea85f2],.handle[data-v-baea85f2]{padding-top:8px;padding-bottom:8px}.close[data-v-baea85f2]{float:right}input[data-v-baea85f2]{display:inline-block;width:50%}.text[data-v-baea85f2]{margin:20px}", ""]);

// exports
